export enum RoleEnum {
  ADMIN = 'ROLE_ADMIN',
  USER = 'ROLE_USER',
}
